import React from 'react';
const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy for Roomease</h1>
      <p className="mb-4">Effective Date: January 15, 2025</p>
      <p className="mb-4">
        Roomease (“we,” “our,” or “us”) is committed to protecting your privacy. This Privacy Policy outlines the scope of our
        data practices, how we collect, use, store, and safeguard your personal data, and your rights under India’s Digital
        Personal Data Protection Act (DPDPA) and other applicable laws.
      </p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-2">Scope and Applicability</h2>
         <p className="mb-4">This Privacy Policy applies to:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Users who access or use the Roomease mobile application or related services.</li>
        <li>Any data collected, processed, and retained during registration, use, or interaction with our app.</li>
      </ul>
      <p>By using Roomease, you consent to the collection, storage, and use of your personal data as described herein.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-2">Consent</h2>
          <p className="mb-4">We obtain your explicit consent for:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Collecting mandatory data, such as name, phone number, email address, gender, and hobbies.</li>
        <li>Using cookies and tracking technologies to enhance your app experience.</li>
        <li>Fetching location data for match suggestions.</li>
      </ul>
      <p>You may withdraw your consent at any time through the app settings, though this may limit app functionality.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-2">Information We Collect</h2>
      <h3 className="text-xl font-semibold mt-4 mb-2">a. Mandatory Data</h3>
      <ul className="list-disc ml-6 mb-4">
        <li>Personal Data: Name, phone number, email address, gender, and hobbies.</li>
        <li>Location Data: Approximate location fetched using Google API for match suggestions.</li>
        <li>Profile and Interaction Data: Roommate preferences, hobbies, chat history, and app usage activity.</li>
        <li>Device Data: Device type, operating system, and app usage patterns.</li>
      </ul>
      
      <h3 className="text-xl font-semibold mt-4 mb-2">b. Cookies and Tracking Technologies</h3>
      <ul className="list-disc ml-6 mb-4">
        <li>Essential Cookies: Necessary for app functionality (e.g., maintaining login sessions).</li>
        <li>Preference Cookies: To remember your preferences (e.g., language, location).</li>
        <li>Analytics Cookies: To understand app usage and improve features using anonymized data.</li>
      </ul>
      
      <h3 className="text-xl font-semibold mt-4 mb-2">c. Instagram Username (Data Collection)</h3>
      <li>
        We may request users to provide their Instagram username during profile creation or verification. This information is
        collected to gather additional user data and is not linked to Instagram or any third-party service.
      </li>
      
      <h2 className="text-2xl font-semibold mt-6 mb-2">How We Use Your Data</h2>
         <p className="mb-4">We use your data for the following purposes:</p>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Roommate Matching:</strong> Suggesting compatible profiles based on gender, hobbies, and preferences.</li>
        <li><strong>Personalization:</strong> Enhancing app features to provide a tailored user experience.</li>
        <li><strong>Analytics and Service Improvement:</strong> Analyzing anonymized data to improve app functionality and resolve technical issues.</li>
        <li><strong>Communication:</strong> Sending notifications, updates, and responding to inquiries.</li>
        <li><strong>Compliance:</strong> Adhering to applicable legal and regulatory requirements.</li>
      </ul>
          <h2 className="text-2xl font-semibold mt-6 mb-2">d.Purpose of Collection & Limitation for Instagram Usernameata Storage and Retention</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Instagram usernames provided by users are collected as additional user information. While we may use this data for manual verification, Roomease does not guarantee the authenticity of the Instagram accounts provided. Users are solely responsible for providing accurate details.</li>
      </ul>
             <h2 className="text-2xl font-semibold mt-6 mb-2">Sensitive Data</h2>
           <p className="mb-4">We collect sensitive data such as your phone number, email address, and gender to enable account creation, communication, and effective roommate matching.</p>
      <ul className="list-disc ml-6 mb-4">
        <li>  Sensitive data is stored securely and is not visible to other users.</li>
         <li>We handle this information in strict compliance with applicable laws and</li>
      </ul>
     <p className="mb-4">This data is strictly used for:</p>
              <ul className="list-disc ml-6 mb-4">
        <li>Account registration and authentication.</li>
         <li>Secure communication and accurate roommate matching.</li>
      </ul>
      <p>Sensitive data is handled with the utmost priority and is never shared with unauthorized parties.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-2">Data Storage and Retention</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>All user data is stored on secure servers located in India and kept within India.</li>
        <li>Data is retained for 5 years, unless:</li>
         <li>A special request for deletion is made.</li>
        <li>  Retention is required for legal or regulatory reasons.</li>
            <li>Instagram usernames collected for verification and data enrichment purposes</li>
      </ul>
             <p>will be stored securely. Users may request the removal of this information, but this may impact their verification status on Roomease.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-2">Third-Party Services</h2>
      <p>We use trusted third-party services to provide core app functionality, including:</p>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Firebase:</strong> For app analytics and authentication services.</li>
        <li><strong>Google API:</strong> For fetching approximate location data to suggest nearby matches.</li>
      </ul>
        <p>These services operate under their respective privacy policies.These services operate under their respective privacy policies.</p>
        <h2 className="text-2xl font-semibold mt-6 mb-2">Data Breach Policy</h2>
      <p>In the event of a data breach:</p>
      <ul className="list-disc ml-6 mb-4">
        <li> Affected users will be notified promptly via email or app notifications.</li>
        <li>Measures will be taken to secure user data and mitigate risks.</li>
      </ul>
        
      <h2 className="text-2xl font-semibold mt-6 mb-2">Grievance Mechanism</h2>
      <p>We are committed to addressing grievances promptly:</p>
         <ul className="list-disc ml-6 mb-4">
        <li> Acknowledgment: Your complaint will be noted within 3 working days.</li>
        <li>Resolution: Issues will be resolved within 30 working days.</li>
      </ul>
             <p>For assistance, contact:</p>
        <ul className="list-disc ml-6 mb-4">
      <li><strong>Grievance Officer:</strong> Kushagra Arora</li>
      <li><strong>Email:</strong> support@roomease.co.in</li>
      <li><strong>Phone:</strong> 9569994536</li>
      </ul>
        <h2 className="text-2xl font-semibold mt-6 mb-2">Automated Decision-Making</h2>
      <p>Our algorithms are solely used to suggest compatible roommate matches based on shared preferences and data. No other significant decisions are automated.</p>
          <h2 className="text-2xl font-semibold mt-6 mb-2">Security Measures</h2>
      <p>We implement robust measures to protect your data, including:</p>
         <ul className="list-disc ml-6 mb-4">
        <p><strong>a.</strong> Acknowledgment: Your complaint will be noted within 3 working days.</p>
        <p><strong>b.</strong>Resolution: Issues will be resolved within 30 working days.</p>
             <p><strong>c.</strong>Regular Audits: Conducting periodic security assessments to identify vulnerabilities.</p>
             <p><strong>d.</strong>Backup Systems: Performing routine backups to prevent data loss.</p>
      </ul>
        
       <h2 className="text-2xl font-semibold mt-6 mb-2">Children’s Privacy</h2>
      <p>Roomease is strictly for users aged 18 and above.
</p>
         <ul className="list-disc ml-6 mb-4">
        <li> We do not knowingly collect data from children.</li>
        <li>If we discover that a child’s data has been collected, it will be deleted immediately.</li>
      </ul>
        
      <h2 className="text-2xl font-semibold mt-6 mb-2">Updates to This Privacy Policy</h2>
      <p>Significant updates to this policy will be communicated to users via email or in-app notifications.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-2">Contact Us</h2>
      <p><strong>Email:</strong> support@roomease.co.in</p>
      <p><strong>Phone:</strong> 9569994536</p>
    </div>
  );
};
export default PrivacyPolicy;